import { render, staticRenderFns } from "./HomePageWidgetSection.vue?vue&type=template&id=ef2c8f80"
import script from "./HomePageWidgetSection.vue?vue&type=script&lang=ts"
export * from "./HomePageWidgetSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports